"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackContentboard = exports.initApnListeners = void 0;
var logger_1 = require("./logger");
var takeover_1 = require("./takeover");
var lazy_1 = require("./lazy");
function clearWallpaper() {
    var body = document.body;
    if (body) {
        body.style.cssText = '';
    }
}
var tracker = function (apntag, adObj) {
    var loadElement = function (ele) {
        var tagId = ele.getAttribute('id');
        if (tagId) {
            apntag.anq.push(function () { return apntag.showTag(tagId); });
        }
    };
    var callback = function () {
        var element = document.getElementById(adObj.targetId);
        if (element) {
            lazy_1.inscreen(element, loadElement);
        }
        if (adObj.targetId) {
            apntag.anq.push(function () {
                return apntag.attachClickTrackers(adObj, adObj.targetId);
            });
        }
    };
    return callback;
};
function initApnListeners(apntag, appNexusData) {
    if (apntag && apntag.anq) {
        apntag.anq.push(function () {
            var tags = Object.keys(appNexusData.tags);
            // ****** adLoaded --> log inview
            tags.forEach(function (tagId) {
                if (tagId !== 'wallpaper') {
                    apntag.onEvent('adLoaded', tagId, function (adObj) {
                        if (tagId === 'contentboard' &&
                            adObj.source === 'rtb' &&
                            adObj.adType === 'native' &&
                            adObj.native) {
                            apntag.fireImpressionTrackers(adObj);
                        }
                        logger_1.logInview(tagId, adObj);
                        apntag.offEvent('adLoaded', tagId);
                    });
                }
            });
            // ****** adAvailable --> log wallpaper id
            apntag.onEvent('adAvailable', 'wallpaper', function (adObj) {
                logger_1.logCreativeId('wallpaper', adObj.creativeId);
            });
            apntag.onEvent('adAvailable', 'skyscraperleft_1', function () {
                logger_1.logHorseshoe();
            });
            window.addEventListener('blur', function () {
                window.setTimeout(function () {
                    if (document.activeElement instanceof HTMLIFrameElement) {
                        var utif = document.activeElement.parentElement;
                        if (utif) {
                            var element = utif.parentElement;
                            if (element) {
                                logger_1.logClick(element.id);
                            }
                        }
                    }
                }, 0);
            });
            // ****** adNoBid --> clearWallpaper
            apntag.onEvent('adNoBid', 'wallpaper', clearWallpaper);
            takeover_1.initTakeover(apntag);
        });
    }
}
exports.initApnListeners = initApnListeners;
function trackContentboard(apntag, adObj) {
    if (apntag && apntag.anq) {
        apntag.anq.push(function () {
            // ****** temporarily we only track contentboard directly
            if (adObj.source === 'rtb' &&
                adObj.adType === 'native' &&
                adObj.native) {
                setTimeout(tracker(apntag, adObj), 100);
            }
        });
    }
}
exports.trackContentboard = trackContentboard;
